export const vibeKeys = {
    VIBE: 'VIBE',
}
